import config from '../config';

function getLogoUrl(logo: string): Record<string, string> {
    return { [logo]: `${config.domain}/${config.logosFolder}/${logo}.svg` };
}

export type BridgeWarLogos = Record<string, string>;

export const bridgeWarLogos: BridgeWarLogos = {
    ...getLogoUrl('bridgeWar'),
    ...getLogoUrl('bridgeWarHeroes'),
    ...getLogoUrl('bridgeWarChallenger'),
    ...getLogoUrl('bridgeWarExtreme'),
};
